import { render, staticRenderFns } from "./estadisticasPanel.vue?vue&type=template&id=634d5614&scoped=true&"
import script from "./estadisticasPanel.vue?vue&type=script&lang=js&"
export * from "./estadisticasPanel.vue?vue&type=script&lang=js&"
import style0 from "./estadisticasPanel.vue?vue&type=style&index=0&id=634d5614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d5614",
  null
  
)

export default component.exports